var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.556 1.894a7.988 7.988 0 0 1-2.305.636A4.046 4.046 0 0 0 19.015.295a8.013 8.013 0 0 1-2.547.98A3.995 3.995 0 0 0 13.539 0c-2.216 0-4.012 1.808-4.012 4.04 0 .315.036.624.104.92A11.365 11.365 0 0 1 1.361.739a4.044 4.044 0 0 0-.543 2.03c0 1.402.709 2.639 1.785 3.363a3.971 3.971 0 0 1-1.817-.505v.05a4.035 4.035 0 0 0 3.218 3.961 3.994 3.994 0 0 1-1.812.07 4.02 4.02 0 0 0 3.748 2.805 8.015 8.015 0 0 1-4.983 1.729c-.324 0-.643-.02-.957-.056A11.303 11.303 0 0 0 6.15 16c7.38 0 11.415-6.155 11.415-11.493 0-.175-.004-.349-.011-.523a8.168 8.168 0 0 0 2.002-2.09"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.386dc383.svg";
export { ForwardRef as ReactComponent };